import { createApp } from "vue";
import PipPlayer from "@/components/Streaming/PipPlayer.vue";
import store from "@/store";

class PipService {
    constructor() {
        this.pipWindow = null;

        this.playerEl = null;
        this.playerParent = null;

        this.app = null;

        this.onClose = null;


        this.resizeHandler = null;
        this.mouseEnterHandler = null;
        this.mouseLeaveHandler = null;
        this.pageHideHandler = null;

        this.hideTimer = null;
    }
    async open(videoPlayer,
        width = 800,
        height = 600
    ) {
        if (this.pipWindow) {
            return;
        }

        const playerEl = videoPlayer.el();
        if (!playerEl) {
            console.error("PiP player element 없음");
            return;
        }
        this.pipWindow = await window.documentPictureInPicture.requestWindow({
            width: Math.round(width),
            height: Math.round(height)
        });
        this.playerEl = playerEl;
        this.playerParent = playerEl.parentNode;

        await this.copyStyles();
        const pipDoc = this.pipWindow.document;

        /*
            root
        */
        const root = pipDoc.createElement("div");
        root.className = "pip-root";
        pipDoc.body.appendChild(root);

        this.root = root;

        /*
            video
        */
        const videoContainer = pipDoc.createElement("div");
        videoContainer.className = "pip-video";
        root.appendChild(videoContainer);

        playerEl.style.width = "100%";
        playerEl.style.height = "100%";

        videoContainer.appendChild(playerEl);

        requestAnimationFrame(() => {
            playerEl.style.width = "";
            playerEl.style.height = "";
            try {
                videoPlayer.trigger("resize");
            } catch (e) { }
        });

        /*
            Vue controls
        */
        const mountEl = pipDoc.createElement("div");
        mountEl.className ="pip-player";
        root.appendChild(mountEl);

        this.app = createApp(PipPlayer);
        this.app.provide(
            "pipVideoPlayer",
            videoPlayer
        );

        this.app.use(store);
        this.app.mount(mountEl);

        /*
            CSS
        */

        const style = pipDoc.createElement("style");

        style.textContent = `
        html,
        body {
            margin:0;
            padding:0;
            width:100%;
            height:100%;
            overflow:hidden;
            background:black;
        }
        .pip-root {
            position:fixed;
            inset:0;
            width:100vw;
            height:100vh;
            overflow:hidden;
            background:black;
        }
        .pip-video {
            position:absolute;
            inset:0;
            width:100%;
            height:100%;
            display:flex;
            align-items:center;
            justify-content:center;
            background:black;
        }
        .pip-video .video-js {
            width:100% !important;
            height:100% !important;
            background:black !important;
        }
        .pip-video .vjs-tech {
            width:100% !important;
            height:100% !important;
            object-fit:contain !important;
        }
        .pip-player {
            opacity:0;
            transition:opacity .2s;
            pointer-events:none;
        }
        .pip-player.show {
            opacity:1;
        }
        .pip-player > * {
            pointer-events:auto;
        }
        `;

        pipDoc.head.appendChild(style);

        /*
            Video.js control 초기 숨김
        */

        setTimeout(() => {
            try {
                videoPlayer.userActive(false);
            } catch (e) { }
        }, 500);

        /*
            resize
        */

        this.resizeHandler = () => {
            requestAnimationFrame(() => {
                try {
                    videoPlayer.trigger("resize");
                } catch (e) { }
            });
        };

        this.pipWindow.addEventListener("resize", this.resizeHandler);

        /*
            mouse control
        */
        this.mouseEnterHandler = () => {
            clearTimeout(this.hideTimer);
            mountEl.classList.add("show");
            try {
                videoPlayer.userActive(true);
            } catch (e) { }
        };

        this.mouseLeaveHandler = () => {
            clearTimeout(this.hideTimer);
            this.hideTimer = setTimeout(() => {
                mountEl.classList.remove("show");
                try {
                    videoPlayer.userActive(false);
                } catch (e) { }
            }, 2000);
        };

        root.addEventListener("mouseenter", this.mouseEnterHandler);
        root.addEventListener("mouseleave", this.mouseLeaveHandler);

        /*
            close
        */

        this.pageHideHandler = async () => {
            await this.close();
            this.onClose?.();
        };

        this.pipWindow.addEventListener("pagehide", this.pageHideHandler);
    }
    restoreVideo() {
        if (this.playerEl && this.playerParent) {
            this.playerParent.appendChild(this.playerEl);
        }
    }
    async close() {
        clearTimeout(this.hideTimer);
        /*
            event 제거
        */
        if (this.pipWindow) {
            if (this.resizeHandler) {
                this.pipWindow.removeEventListener("resize", this.resizeHandler);
            }
            if (this.pageHideHandler) {
                this.pipWindow.removeEventListener("pagehide", this.pageHideHandler);
            }
            if (this.mouseEnterHandler) {
                this.root?.removeEventListener("mouseenter", this.mouseEnterHandler);
            }
            if (this.mouseLeaveHandler) {
                this.root?.removeEventListener("mouseleave", this.mouseLeaveHandler);
            }
        }

        if (this.app) {
            this.app.unmount();
            this.app = null;
        }

        this.restoreVideo();

        if (this.pipWindow) {
            this.pipWindow.close?.();
        }

        this.pipWindow = null;
        this.playerEl = null;
        this.playerParent = null;
        this.resizeHandler = null;
        this.mouseEnterHandler = null;
        this.mouseLeaveHandler = null;
        this.pageHideHandler = null;
    }
    async copyStyles() {
        if (!this.pipWindow)
            return;

        const pipDoc = this.pipWindow.document;

        for (const sheet of document.styleSheets) {
            try {
                const css = [...sheet.cssRules].map(r => r.cssText).join("\n");
                const style = pipDoc.createElement("style");
                style.textContent = css;
                pipDoc.head.appendChild(style);
            } catch (e) {
                // cross origin skip
            }
        }
    }
}
export default new PipService();